import { render, staticRenderFns } from "./CardButton.vue?vue&type=template&id=1af8141d&scoped=true&"
import script from "./CardButton.vue?vue&type=script&lang=js&"
export * from "./CardButton.vue?vue&type=script&lang=js&"
import style0 from "./CardButton.vue?vue&type=style&index=0&id=1af8141d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af8141d",
  null
  
)

export default component.exports